import { Typography } from "@mui/material"
import { FooterItem } from "../types"
import { footerStyles } from "../styles/footerStyles"

export const FooterLink = ({ url, label }: FooterItem) => {
  const { classes } = footerStyles()
  return (
    <Typography key={url} variant="body2" className={`${classes.separator}`}>
      <a href={url}>{label}</a>
    </Typography>
  )
}
